import CollectionEditor from "#root/components/collection-editor";
import * as Fields from "#root/components/form/fields";
import { getBillingInvoiceItemCollection } from "#root/schema/invoices";
import { productCollection } from "#root/schema/product";
import type { ReactNode } from "react";
import { Fragment, useMemo } from "react";
import PageLayout from "./layout";

export default function ({ invoiceId }): ReactNode {
  const invoiceItemsCollection = useMemo(() => getBillingInvoiceItemCollection(invoiceId), [invoiceId]);

  return (
    <PageLayout title="Billing - Edit Invoice Items">
      <section>
        <h2>Edit Invoice Items</h2>
        <CollectionEditor
          collection={invoiceItemsCollection}
          header={
            <div className="row header">
              <div className="cell">Product Description</div>
              <div className="cell">Rate</div>
              <div className="cell">Quantity</div>
              <div className="cell">Interval</div>
              <div className="cell">Linked Product</div>
              <div className="cell">Action</div>
            </div>
          }
        >
          {({ message, id }) => (
            <Fragment>
              <div className="row">
                <div className="cell">
                  <Fields.Set name="id" className="hidden">
                    <Fields.Hidden/>
                  </Fields.Set>
                  <Fields.Set name="description" style={{ minWidth: "20em" }}>
                    <Fields.String/>
                  </Fields.Set>
                </div>
                <div className="cell">
                  <Fields.Set name="rate" style={{ maxWidth: "6em" }}>
                    <Fields.Currency/>
                  </Fields.Set>
                </div>
                <div className="cell">
                  <Fields.Set name="quantity" style={{ maxWidth: "4em" }}>
                    <Fields.Integer/>
                  </Fields.Set>
                </div>
                <div className="cell">
                  <Fields.Set name="interval" style={{ minWidth: "7em" }}>
                    <Fields.Select required>
                      <Fields.Option value="One-Time">One-Time</Fields.Option>
                      <Fields.Option value="Monthly">Monthly</Fields.Option>
                      <Fields.Option value="Quarterly">Quarterly</Fields.Option>
                      <Fields.Option value="Yearly">Yearly</Fields.Option>
                    </Fields.Select>
                  </Fields.Set>
                </div>
                <div className="cell">
                  <Fields.Set name="productId" style={{ maxWidth: "12em" }}>
                    <Fields.AutoComplete collection={productCollection}/>
                  </Fields.Set>
                </div>
                <div className="cell">
                  &nbsp;
                  <Fields.Submit>{id ? "Save" : "Add Item"}</Fields.Submit>
                  {id ? <Fields.Delete>Delete</Fields.Delete> : null}
                </div>
              </div>
            </Fragment>
          )}
        </CollectionEditor>
      </section>
    </PageLayout>
  );
}
